"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PromoModal = void 0;
var _react = _interopRequireDefault(require("react"));
var _Button = require("../../../elements/button/Button");
var _noScroll = require("../../../utils/scroll/noScroll");
var _Modal = require("../../modal/Modal");
var styles = _interopRequireWildcard(require("./promo-messages.module.scss"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var PromoModal = exports.PromoModal = function PromoModal(_ref) {
  var onClose = _ref.onClose,
    promos = _ref.promos,
    productUrl = _ref.productUrl;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Modal.Modal, {
    className: styles.promo__modal,
    footer: false,
    isOpen: true,
    onClose: onClose,
    title: "Offers",
    children: [promos.map(function (promo) {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
        className: styles['promo--plain'],
        "data-testid": "product-card-promo-message",
        children: promo
      }, promo);
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.UnderlinedButton, {
      href: productUrl,
      onClick: function onClick() {
        return (0, _noScroll.setNoScroll)(false);
      },
      tag: "a",
      children: "View full product information"
    })]
  });
};